import { gql } from '@apollo/client';

export const DELETE_APPLIED_JOB = gql`
  mutation DeleteAppliedJob($input: DeleteAppliedJobInput!, $locale: Locale) {
    deleteAppliedJob(input: $input) {
      ... on DeleteAppliedJobSuccess {
        id
      }
      ... on DeleteAppliedJobFailure {
        errors {
          message(locale: $locale)
        }
      }
    }
  }
`;
